import { getDefaultHeader } from '../../services/serviceAPIHelper';
import { getUserInformation } from '../Login/loginService';

export const getAgency = function () {
    let user = getUserInformation();
    const url = process.env.REACT_APP_API_URL + 'agency/' + user.user_detail.agency_code;
    return fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    }).then(response => {
        if(response.ok) {    
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};

export const saveAgency = function (agency) {
    const user = getUserInformation();
    const url = process.env.REACT_APP_API_URL + 'agency/' + user.user_detail.agency_code;
    return fetch(url, {
        method: 'PUT',
        headers: getDefaultHeader(true),
        body:JSON.stringify(agency)
    }).then(response => {
        if(response.ok) {    
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};


// WEBPACK FOOTER //
// ./src/components/Agency/agencyServices.js